import {
  type EABFilterImplementation,
  EABFilterImplementationType,
  EABFilterType,
  type FilterOption,
  SQDCActionStatus,
} from "@/graphql";
import type { EventFilter } from "../FilterTypes";
import EventActionRelationFilterUI from "../ui/EventActionRelationFilterUI.vue";
import EventActionRelationFilterBadge from "../ui/badges/EventActionRelationFilterBadge.vue";
import notEmpty from "@/functions/notEmpty";

export enum EventActionRelationFilterOptions {
  WITHOUT_ACTION = "WITHOUT_ACTION",
  ONLY_ACT_ACTIONS = "ONLY_ACT_ACTIONS",
}

export default class EventActionRelationFilter implements EventFilter {
  constructor(
    public readonly filters: EventActionRelationFilterOptions[],
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = EventActionRelationFilterBadge;

  static readonly UI = EventActionRelationFilterUI;

  getEventFilter(): FilterOption | undefined {
    const typeFilter: EABFilterImplementation | undefined = this.filters.includes(
      EventActionRelationFilterOptions.ONLY_ACT_ACTIONS,
    )
      ? {
          type: EABFilterImplementationType.ACTION_STATUS,
          value: {
            value: [SQDCActionStatus.ACT],
            negated: this.isNegated ?? false,
          },
        }
      : undefined;

    const idFilter: EABFilterImplementation | undefined = this.filters.includes(
      EventActionRelationFilterOptions.WITHOUT_ACTION,
    )
      ? {
          type: EABFilterImplementationType.EVENT_HAS_ACTIONS,
          value: {
            value: false,
            negated: this.isNegated ?? true,
          },
        }
      : undefined;

    const filters = [typeFilter, idFilter].filter(notEmpty).map((filter) => ({ filter }));

    if (filters.length === 0) {
      return undefined;
    }

    return {
      operation: {
        type: this.isNegated ? EABFilterType.AND : EABFilterType.OR,
        filters,
      },
    };
  }
}
